import "./ProblemsTable.css"
import Problem from "./SingleProblem"
import problems_json from '../../../Data/Problems.json';
import { useEffect } from "react";
import redirectFunc from "../../../ClientProblemRouter/useRedirectToProblem.js";

export default function ProblemsTable({searchbar_content, topic_checkboxes, difficulty_checkboxes, modality_checkboxes, page_number, set_num_problems, solved_problems}){

    const ProblemRouter = redirectFunc();

    const filtered_problems = problems_json.filter((problem) => {
        return (searchbar_content == ""            || problem.problem_name.toLowerCase().includes(searchbar_content.toLowerCase())) &&
               (difficulty_checkboxes.length === 0 || difficulty_checkboxes.includes(problem.problem_difficulty)) &&
               (topic_checkboxes.length === 0      || topic_checkboxes.includes(problem.problem_topic))           &&
               (modality_checkboxes.length === 0   || modality_checkboxes.includes(problem.problem_modality));
    });
        
    const problems_table = filtered_problems.slice(page_number * 15, page_number * 15 + 15)
        .map((problem, index) => {
            return <Problem 
                problem_name={problem.problem_name} 
                problem_difficulty={problem.problem_difficulty}
                problem_topic={problem.problem_topic} 
                problem_modality={problem.problem_modality}
                even_or_odd={(index+1)%2}
                problem_id={problem.problem_id}
                solved={solved_problems.includes(problem.problem_id)}
                click_handler={() => ProblemRouter(problem.problem_id)}
            />
    });

    useEffect(() =>{
        set_num_problems(filtered_problems.length);
    },[filtered_problems.length]);

    return(
        <div className="outer-box">
            <div className="headers">
                <div className="Name header">
                    Problem Name:
                </div>
                <div className="Difficulty header">
                    Difficulty:
                </div>
                <div className="Topic header">
                    Topic:
                </div>
                <div className="Modality header"> 
                    Modality:
                </div>
            </div>
            {problems_table}
        </div>
    );
}